import { createProfileConstants } from '../_constants';
import { createProfileService } from '../_services';
import { alertActions } from './';

export const createProfileActions = {
  getAll,
  createProfile,
  getAllGISS,
  getAllResource,
};

function getAll() {
  return (dispatch) => {
    dispatch(request());

    createProfileService.getAll().then(
      (listAll) => dispatch(success(listAll)),
      (error) => dispatch(failure(error)),
    );
  };

  function request() {
    return { type: createProfileConstants.GETALL_REQUEST };
  }
  function success(listAll) {
    return { type: createProfileConstants.GETALL_SUCCESS, listAll };
  }
  function failure(error) {
    return { type: createProfileConstants.GETALL_FAILURE, error };
  }
}

function getAllGISS() {
  return (dispatch) => {
    dispatch(request());

    createProfileService.getAllGISS().then(
      (listAll) => dispatch(success(listAll)),
      (error) => dispatch(failure(error)),
    );
  };
  /**Keeping the same store value as its similar in structure */
  function request() {
    return { type: createProfileConstants.GETALL_REQUEST };
  }
  function success(listAll) {
    return { type: createProfileConstants.GETALL_SUCCESS, listAll };
  }
  function failure(error) {
    return { type: createProfileConstants.GETALL_FAILURE, error };
  }
}

function getAllResource() {
  return (dispatch) => {
    dispatch(request());

    createProfileService.getAllResource().then(
      (listAll) => dispatch(success(listAll)),
      (error) => dispatch(failure(error)),
    );
  };
  /**Keeping the same store value as its similar in structure */
  function request() {
    return { type: createProfileConstants.GETALL_REQUEST };
  }
  function success(listAll) {
    return { type: createProfileConstants.GETALL_SUCCESS, listAll };
  }
  function failure(error) {
    return { type: createProfileConstants.GETALL_FAILURE, error };
  }
}

function createProfile(data) {
  return (dispatch) => {
    dispatch(request(data));

    createProfileService.createProfile(data).then(
      () => {
        dispatch(success());
        dispatch(alertActions.success('Registration successful'));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      },
    );
  };

  function request(data) {
    return { type: createProfileConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: createProfileConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: createProfileConstants.CREATE_FAILURE, error };
  }
}
